import { useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './AuthContext'; // Pas het pad aan naar je AuthContext
import './ConfigCompany.css'; // Importeer de bijbehorende CSS
import backicon from './Back Icon.png';
import icon_MyAccount from './My Account Icon.png';
import icon_Logout from './Logout Icon.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import icon_ConfigCompany from './Icon Config Company.png';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import img_RidderIQ_ServerDatabase from './img_HelpRidderIQ_ServerDatabase.jpg';
import img_RidderIQ_VerificationMethod from './img_HelpRidderIQ_VerificationMethod.jpg'
import api from './axios';

const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 1000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    transform: 'scale(1)', // Begin iets kleiner
    transition: 'transform 1s ease-in-out', // Overgangseffect
    borderRadius: '5px', // Afgeronde hoeken
  };
  
const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };


function ConfigCompany() {
    const { user, companyId, companyName, updateUser, logout, switchCompany } = useAuth();
    const [menu2Open, setMenu2Open] = useState(false);
    const menu2Ref = useRef(null);
    const navigate = useNavigate();  
    const [activeMenu, setActiveMenu] = useState('connection');  // Standaard is 'connection' actief
    const { reportId } = useParams();
    const [reportParameters, setReportParameters] = useState([]);
    const [reportRefreshSchedule, setReportRefreshSchedule] = useState([]);
    const [gatewayDatasources, setGatewayDatasources] = useState([]);
    const [DatasetGatewayDatasources, setDatasetGatewayDatasources] = useState([]);
    const [licensedUsers, setLicensedUsers] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [gatewayNeeded, setGatewayNeeded] = useState(null);
    const [PBIServiceSettingsNeeded, setPBIServiceSettingsNeeded] = useState(null);
    const [PBIServiceSettings_URL, setPBIServiceSettings_URL] = useState(null);
    const [gatewayName, setGatewayName] = useState("");
    const [gateway_UserPrincipal, setGatewayUserPrincipal] = useState(null);
    const [gateway_UserPassword, setGatewayUserPassword] = useState(null);
    const [gatewayId, setGatewayId] = useState(null);
    const [reportName, setReportName] = useState(null);  
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [serverName, setServername] = useState('');
    const [databaseName, setDatabasename] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [reload, setReload] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [showCommentPopup, setShowCommentPopup] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [parameterValues, setParameterValues] = useState({});
    const [parametersChanged, setParametersChanged] = useState(false);
    const [selectedHours, setSelectedHours] = useState(Array(8).fill(""));
    const [selectedMinutes, setSelectedMinutes] = useState(Array(8).fill(""));
    const [selectedPeriod, setSelectedPeriod] = useState(Array(8).fill(""));
    const [RShasChanges, setRSHasChanges] = useState(false);
    const [selectedDays, setSelectedDays] = useState([]);
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [selectedCategory, setSelectedCategory] = useState('Support');
    const [Request_message, setRequestMessage] = useState("");
    const [showHelpPopup, setShowHelpPopup] = useState(false);
    const [showHelp_ServernameDatabase, setShowHelp_ServernameDatabase] = useState(false);
    const [showHelp_VerificationMethod, setShowHelp_VerificationMethod] = useState(false);
    const [verificationMethod, setVerificationMethod] = useState("Windows");
    const [showQuestionYesNoPopup_ActivateLicense, setShowQuestionYesNoPopup_ActivateLicense] = useState(false);
    const [popupLicenseText, setPopupLicenseText] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(null);

  
    // Deze functie roept je backend API aan om te controleren of er nog een vrije user-licentie beschikbaar is
    async function checkLicenseStatus(cruId) {
      try {
        // 1) Bel je backend via je axios-instance (met cookies/refresh erbij)
        const { data } = await api.post('/api/license_status', { cru_id: cruId });
    
        // 2) Haal de aantallen uit de response
        const { total_active_licenseusers, total_max_number_licenseusers } = data;
    
        // 3) Bouw je bevestigingstekst
        let text = 'Are you sure you want to activate the report?';
        if (total_max_number_licenseusers === 0) {
          text = 'Are you sure you want to activate this report? Please be aware that activating this report will add a license and incur additional costs.';
        } else if (total_active_licenseusers >= total_max_number_licenseusers) {
          text = 'Are you sure you want to activate this report? Please be aware that activating this report will add a new license and incur additional costs.';
        }
        setPopupLicenseText(text);
        setShowQuestionYesNoPopup_ActivateLicense(true);
    
      } catch (err) {
        // 401 → token verlopen / sessie verlopen
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId}`);
          return;
        }
    
        // Andere fouten gewoon doorgeven
        console.error('Error fetching license status:', err);
        setError(err.response?.data?.error || err.message);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    }

    const handleSendHelpButton = async (event) => {
      event.preventDefault();
      setShowHelpPopup(false);
    
      try {
        // Alles via je axios-instance, die automatisch token & cookies meegeeft:
        await api.post('/api/requestforsupport/', {
          user_id:          user.id,
          user_email:       user.email,
          user_name:        user.name,
          company_id:       companyId,
          company_name:     companyName,
          Request_category: selectedCategory,
          Request_message:  Request_message,
          currentURL:       window.location.href
        });
    
        // Succesmelding
        setMessage('Request for support sent successfully');
        setShowPopupMessage(true);
        setTimeout(() => setShowPopupMessage(false), 3000);
    
      } catch (err) {
        // 401 → sessie verlopen, dan uitloggen
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId}`);
          return;
        }
    
        // overige fouten
        setError(err.response?.data?.error || err.message);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    };

    const handleMyProfile = () => {
      navigate('/my-profile');
    };

    const updateLicenseStatus = async (companyIdParam, reportId, targetUserId, isActive) => {
      setIsLoading(true);
    
      try {
        // Doe de call via je axios-instance; token & cookies gaan automatisch mee
        const { data } = await api.post('/api/updateLicenseStatus', {
          company_id:           companyIdParam,
          report_id:            reportId,
          user_id:              targetUserId,
          active:               isActive,
          createdby_user_id:    user.id
        });
    
        // Werk de lijst met gelicenseerde gebruikers bij
        setLicensedUsers(data.updatedUsers);
    
        // Toon succesmelding
        setMessage('License status successfully updated');
        setShowPopupMessage(true);
    
      } catch (err) {
        // 401 → sessie verlopen, dan uitloggen
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId}`);
          return;
        }
    
        // overige fouten
        setError(err.response?.data?.error || err.message);
        setShowErrorPopup(true);
    
      } finally {
        setIsLoading(false);
        // verberg popups na 3s
        setTimeout(() => setShowPopupMessage(false), 3000);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    };

    const updateVisibleStatus = async (companyIdParam, reportId, targetUserId, isVisible) => {
      setIsLoading(true)
    
      try {
        // call via je Axios-instance: cookies/token gaan automatisch mee
        const { data } = await api.post('/api/updateVisibleStatus', {
          company_id: companyIdParam,
          report_id: reportId,
          user_id: targetUserId,
          visible: isVisible
        })
    
        // bijgewerkte gebruikerslijst
        setLicensedUsers(data.updatedUsers)
    
        // succesmelding
        setMessage('Visibility status successfully updated')
        setShowPopupMessage(true)
    
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
          return
        }
    
        // overige fouten
        setError(err.response?.data?.error || err.message)
        setShowErrorPopup(true)
    
      } finally {
        setIsLoading(false)
        // popups weer uitschakelen na 3s
        setTimeout(() => setShowPopupMessage(false), 3000)
        setTimeout(() => setShowErrorPopup(false), 3000)
      }
    }

    const handleLicenseChange = (index) => {
      const newLicensedUsers = [...licensedUsers]
      newLicensedUsers[index].active = newLicensedUsers[index].active === 1 ? 0 : 1
      setLicensedUsers(newLicensedUsers)           // direct in de UI updaten
      setIsLoading(true)
    
      updateLicenseStatus(
        companyId,
        reportId,
        newLicensedUsers[index].userId,
        newLicensedUsers[index].active
      )
    }
    
    const handleVisibleChange = (index) => {
      const newLicensedUsers = [...licensedUsers]
      newLicensedUsers[index].visible = newLicensedUsers[index].visible === 1 ? 0 : 1
      setLicensedUsers(newLicensedUsers)           // direct in de UI updaten
      setIsLoading(true)
    
      updateVisibleStatus(
        companyId,
        reportId,
        newLicensedUsers[index].userId,
        newLicensedUsers[index].visible
      )
    }
  
    const handleDayChange = (day) => {
      setRSHasChanges(true);
      setSelectedDays(prevDays => {
          if (prevDays.includes(day)) {
              return prevDays.filter(d => d !== day);
          } else {
              return [...prevDays, day];
          }
      });
    };

    const handleHourChange = (index, hour) => {
      setRSHasChanges(true);
      setSelectedHours(prevHours => {
          const newHours = [...prevHours];
          newHours[index] = hour;
          return newHours;
      });
      // Als er een uur is geselecteerd, stel dan de minuten en periode in op standaardwaarden
      if (hour) {
          setSelectedMinutes(prevMinutes => {
              const newMinutes = [...prevMinutes];
              newMinutes[index] = "00";
              return newMinutes;
          });
          setSelectedPeriod(prevPeriod => {
              const newPeriod = [...prevPeriod];
              newPeriod[index] = "AM";
              return newPeriod;
          });
      } else {
          // Als er geen uur is geselecteerd, maak dan de bijbehorende minuten en periode leeg
          setSelectedMinutes(prevMinutes => {
              const newMinutes = [...prevMinutes];
              newMinutes[index] = "";
              return newMinutes;
          });
          setSelectedPeriod(prevPeriod => {
              const newPeriod = [...prevPeriod];
              newPeriod[index] = "";
              return newPeriod;
          });
      }
    };
 
    const handleMinuteChange = (index, value) => {
      setSelectedMinutes(prev => {
          const arr = [...prev];
          arr[index] = value;
          return arr;
      });
      if (selectedHours[index]) {
          setRSHasChanges(true);
      }
    };
  
    const handlePeriodChange = (index, value) => {
        setSelectedPeriod(prev => {
            const arr = [...prev];
            arr[index] = value;
            return arr;
        });
        if (selectedHours[index]) {
            setRSHasChanges(true);
        }
    };
  

    const handleParameterValueChange = (index, newValue) => {
      const newParameterValues = { ...parameterValues, [index]: newValue };
      setParameterValues(newParameterValues);
      setParametersChanged(true);
    };
  
    const handleUpdateParameters = async () => {
      try {
        setIsLoading(true)
    
        // Stap 1: Bouw de updateDetails array
        const updateDetails = reportParameters.value
          .filter(param => param.name !== "Version")
          .map((param, index) => ({
            name: param.name,
            newValue: parameterValues[index] ?? param.currentValue
          }))
    
        // Stap 2: Stel de request payload samen
        const requestData = {
          value_parent: { updateDetails },
          company_id:  companyId,
          report_id:    reportId
        }
    
        // Stap 3: Verstuur via jouw axios-instance
        const { data } = await api.post('/api/updateParameters', requestData)
    
        // Succes
        setMessage('Parameter values successfully updated')
        setShowPopupMessage(true)
        setTimeout(() => {
          setShowPopupMessage(false)
          setIsLoading(false)
        }, 3000)
    
        // Reset de “changed” flag
        setParametersChanged(false)
    
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
          return
        }
    
        // Andere fout
        const msg = err.response?.data?.error || err.message
        console.error('Error updating parameter values:', msg)
        setError('An error occurred updating parameter values: ' + msg)
        setShowErrorPopup(true)
        setTimeout(() => {
          setShowErrorPopup(false)
          setIsLoading(false)
        }, 3000)
      }
    }

      
    const handleUpdateRefreshSchedule = async () => {
      try {
        // Filter geselecteerde dagen
        const filteredDays = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
          .filter(day => selectedDays.includes(day))
    
        // Zet geselecteerde uren om naar 24-uursformaat
        const formattedTimes = selectedHours.map((hour, idx) => {
          if (!hour) return null
          let h = parseInt(hour, 10)
          if (selectedPeriod[idx] === 'PM' && hour !== '12') h += 12
          if (selectedPeriod[idx] === 'AM' && hour === '12') h = 0
          return `${String(h).padStart(2,'0')}:${selectedMinutes[idx]}`
        })
        const uniqueTimes = [...new Set(formattedTimes.filter(t => t))]
    
        // Bouw payload
        const requestData = {
          value_tmp: {
            value: {
              enabled: true,
              days: filteredDays,
              times: uniqueTimes,
              localTimeZoneId: 'W. Europe Standard Time'
            }
          },
          company_id: companyId,
          report_id: reportId
        }
    
        // Verzoek via axios-instance
        const { data } = await api.post('/api/updateRefreshSchedule', requestData)
    
        // Backend bevestiging
        if (data.success) {
          setMessage('Refresh schedule successfully updated')
          setShowPopupMessage(true)
          setTimeout(() => setShowPopupMessage(false), 3000)
          setRSHasChanges(false)
        } else {
          throw new Error(data.error || 'Unknown error')
        }
    
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
          return
        }
        // Andere fout
        const msg = err.response?.data?.error || err.message
        console.error('Error updating refresh schedule:', msg)
        setError('Error updating refresh schedule: ' + msg)
        setShowErrorPopup(true)
        setTimeout(() => setShowErrorPopup(false), 3000)
      }
    }

    const handleButton_CreateDatasource = async () => {
      if (!isButtonActive) return
    
      setIsLoading(true)
    
      try {
        const { data } = await api.post('/api/createGatewayDatasource', {
          user_id:               user.id,
          company_id:            companyId,
          report_id:             reportId,
          credentials_username:  username,
          credentials_password:  password,
          gw_ds_servername:      serverName,
          gw_ds_database:        databaseName,
          verificationMethod
        })
    
        if (data.success) {
          setReload(prev => !prev)             // trigger fetch opnieuw
          setMessage('You have successfully created the datasource')
          setShowPopupMessage(true)
          setTimeout(() => setShowPopupMessage(false), 3000)
        } else {
          throw new Error(data.error || 'Unknown error')
        }
    
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
          return
        }
    
        // andere foutmelding
        const msg = err.response?.data?.error || err.message
        console.error('Error creating datasource:', msg)
        setError('Error creating datasource: ' + msg)
        setShowErrorPopup(true)
        setTimeout(() => setShowErrorPopup(false), 3000)
    
      } finally {
        setIsLoading(false)
      }
    }

    const handleButton_OpenPowerBISettings = async () => {
      try {
        await api.post('/api/setReportConnected', {
          company_id: companyId,
          report_id: reportId
        })
        console.log('Report connection status successfully set')
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          navigate(`/login/${companyId}`)
          return
        }
        // andere fout
        console.error('Error setting report connection status:', err.response?.data?.error || err.message)
      }
    }

    const togglePasswordVisibility = () => {
      setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const handleInputChange = (e, setter) => {
      setter(e.target.value);
    };

    const isButtonActive = username.length > 0 && password.length > 0 && serverName.length > 0 && databaseName.length > 0;

    const handleLogout = async () => {
      // Roept de context-logout aan (wis server-cookies en context-state)
      await logout()
      // Navigeer naar de loginpagina voor de huidige company
      navigate(`/login/${companyId}`)
    }

      const handleSwitchCompany = () => {
        navigate('/my-companies');
      };

      
      const handleClickOutside = (event) => {
        if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
          setMenu2Open(false);
        }
      };

      const handleMenu_Help = () => {
        setShowHelpPopup(true);
      };

      useEffect(() => {

      }, [selectedDays]);

      useEffect(() => {
        setSelectedDays(reportRefreshSchedule.days);
      }, [reportRefreshSchedule.days]);
    
      useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        // Opruimen bij ontkoppeling
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []); // Geen afhankelijkheden, alleen bij mounten en ontkoppelen

      useEffect(() => {
        // Wacht tot user uit context is geladen
        if (!user) return;
      
        setIsLoading(true);
      
        async function fetchData() {
          try {
            // Ophalen via je axios-instance (stuurt cookies/tokens automatisch mee)
            const { data } = await api.get(
              `/api/getconfigcompanyreport/${user.id}/${companyId}/${reportId}`
            );
      
            // (optioneel) kleine vertraging om je loader mooi te kunnen zien
            await new Promise(resolve => setTimeout(resolve, 1000));
      
            // Zet loading uit zodra data binnen is
            setIsLoading(false);
      
            // Vul je state met de ontvangen data, met fallback naar lege arrays of defaults
            setReportParameters(data.reportParameters || []);
            setReportRefreshSchedule(data.reportRefreshSchedule || []);
            setLicensedUsers(data.licensedUsers || []);
            setGatewayDatasources(data.gateway_datasources || []);
            setDatasetGatewayDatasources(data.dataset_gateway_datasources || []);
            setGatewayNeeded(data.gateway_needed === 1);
            setPBIServiceSettingsNeeded(data.pbi_service_settings_needed === 1);
            if (data.pbi_service_settings_needed === 1) {
              setPBIServiceSettings_URL(
                `https://app.powerbi.com/groups/${data.workspace_id}/settings/datasets/${data.PBI_dataset_id}?ctid=3cdc3671-b8ef-411a-bfa7-febdbe0bec95&experience=power-bi`
              );
            }
            setGatewayName(data.gateway_name || "");
            setGatewayUserPrincipal(data.gateway_userprincipal || null);
            setGatewayUserPassword(data.gateway_userpassword || null);
            setGatewayId(data.gateway_id || null);
      
            setUserRole(data.roleId ?? 3); // default = Viewer
            setReportName(data.report_name ? `'${data.report_name}'` : null);
      
            // Als de backend een nieuwe companyName teruggeeft, update zowel context als dropdown
            if (data.companyName) {
              // 1) update context (ook localStorage achter de schermen)
              updateUser({ default_companyname: data.companyName });
              // 2) update actieve company in context (bv. om navigatie-links goed te laten werken)
              switchCompany(companyId, data.companyName);
            }
          } catch (err) {
            setIsLoading(false);
            // 401 afgehandeld door axios-interceptor; hier alleen loggen
            console.error("Error loading report-config:", err);
          }
        }
      
        fetchData();
      }, [
        user?.id,           // wanneer de ingelogde user verandert
        companyId,     // bij andere companyId uit URL
        reportId,           // bij ander report
        reload               // jouw trigger om opnieuw te laden
      ]);

    useEffect(() => {
        if (reportRefreshSchedule && reportRefreshSchedule.times) {
            const hoursArray = [];
            const minutesArray = [];
            const periodArray = [];

            reportRefreshSchedule.times.forEach(time => {
                const [hourStr, minuteStr] = time.split(':');
                let hour = parseInt(hourStr, 10);
                let period = 'AM';

                if (hour > 12) {
                    hour -= 12;
                    period = 'PM';
                }

                hoursArray.push(hour);
                minutesArray.push(minuteStr);
                periodArray.push(period);
            });

            // Voor de resterende indices die geen tijd hebben, stellen we de waarden in op leeg
            while (hoursArray.length < 8) {
                hoursArray.push("");
                minutesArray.push("");
                periodArray.push("");
            }

            setSelectedHours(hoursArray);
            setSelectedMinutes(minutesArray);
            setSelectedPeriod(periodArray);
        }
    }, [reportRefreshSchedule]);

    const handleSelectVerificationMethodChange = (event) => {
      setVerificationMethod(event.target.value);
    };

      // Als de gebruiker niet is ingelogd, render dan niets
    if (!user) 
    {
        //+navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina // Redirect naar de loginpagina
        return null;
    }

    // Toon 'access denied' de pagina als de gebruiker geen Admin (1) of Member (2) is
    if (!user || (user.company_roleId !== 1 && user.company_roleId !== 2)) {
      return "Access denied";
    }

  const gatewayFound = gatewayName.length > 0;
  const isReportConnected = DatasetGatewayDatasources && Array.isArray(DatasetGatewayDatasources.value) && DatasetGatewayDatasources.value.some(report => report.reportName && report.datasourceType && report.connectionDetails && report.reportName !== 'No report found');

  return (
    <CSSTransition
      in={true} // Deze waarde verandert wanneer je navigeert
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
    <div className="page">

        <header style={{ borderBottom: '1px solid grey', position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <button className="back-button" onClick={() => navigate(-1)}><img src={backicon} alt="Logo" style={{ height: '5vh', margin: '15px' }} /></button>
            <div className="configCompanies-title">Config company report {reportName}</div>

            <div style={{ position: 'relative' }}>
            <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />
            <img src={icon_MyAccount} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={() => setMenu2Open(!menu2Open)} />
            {menu2Open && (
                <div ref={menu2Ref} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
                <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                    {companyName || 'No company assigned'}
                    {
                      user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                        <a href={`/configcompany/${companyId}`}>
                          <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                        </a>
                      )
                    }
                </div>              
                <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
                <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>
                <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>
                <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
                </div>
            )}
            </div>
        </div>
        </header>
        
        <div className="sidebar-cc">
            <div className="menu-item-cc" onClick={() => setActiveMenu('connection')}>
                <span className={activeMenu === 'connection' ? 'active' : ''}>Connection</span>
            </div>
            <div className="menu-item-cc" onClick={() => setActiveMenu('parameters')}>
                <span className={activeMenu === 'parameters' ? 'active' : ''}>Parameters</span>
            </div>
            <div 
                className={`menu-item-cc ${(!gatewayFound || !isReportConnected) ? 'disabled' : ''}`}
                onClick={() => setActiveMenu('refresh_schedule')}
            >
                <span className={activeMenu === 'refresh_schedule' ? 'active' : ''}>Refresh schedule</span>
            </div>
            <div className="menu-item-cc" onClick={() => setActiveMenu('user_settings')}>
                <span className={activeMenu === 'user_settings' ? 'active' : ''}>User settings</span>
            </div>
        </div>


        <div className="content-cc">

              {activeMenu === 'connection' && (
                <div className="report-table-container-cc">
                    <h3>Report Connection</h3>

                    {PBIServiceSettingsNeeded ? (
                      <div>
                        {/* Inhoud die getoond wordt als PBIServiceSettingsNeeded gelijk is aan 1 */}
                        <div>
                          <p>To connect the report to your Dynamics 365 Business Central administration, you must reference your D365 Business Central credentials to the report once. This can be done in the following steps:</p>
                          <ol>
                            <li>Click on the below button to open the Power BI Service settings in a new browser page. If you don't see anything, copy the URL to try another web browser.</li>
                            <div className="button-container">
                              <button 
                                className="activeButton"
                                style={{ width: '400px', marginBottom: '10px' }}
                                onClick={() => {
                                  window.open(PBIServiceSettings_URL, '_blank');
                                  handleButton_OpenPowerBISettings();
                                }}                                
                              >
                                Open Power BI Service Settings
                              </button>
                              <button 
                                className="activeButton"
                                style={{ width: '150px' }}    
                                onClick={() => {
                                  navigator.clipboard.writeText(PBIServiceSettings_URL)
                                    .then(() => {
                                      setMessage('URL successfully copied to clipboard');
                                      setShowPopupMessage(true);
                                      setTimeout(() => setShowPopupMessage(false), 3000);
                                    })
                                    .catch(err => {
                                      console.error('Failed to copy URL: ', err);
                                      setError('Failed to copy URL');
                                      setShowErrorPopup(true);
                                      setTimeout(() => setShowErrorPopup(false), 3000);
                                    });
                                }}
                              >
                                Copy URL
                              </button>
                            </div>
                            <li>Click on the button 'Take over' and confirm it.</li>
                            <li>Click on the 'Edit credentials' link under Data Source Credentials.</li>
                            <li>Set the privacy level to 'Organizational' and click on Sign in.</li>
                            <li>Log in with your Microsoft Dynamics 365 Business Central account.</li>
                            <li>When successfully logged in, you can close the browser page.</li>
                          </ol>
                          <div className='white-space'></div>
                          <p>The above steps are visualized in the below instruction video:</p>
                          <div style={{ maxWidth: '60%', height: 'auto' }}>
                            <video controls style={{ width: '100%', height: 'auto' }}>
                                  <source src='/Media/Videos/PBI D365 Credential Instructions.mp4' type="video/mp4" />
                                  Your browser does not support the video tag.
                              </video>
                          </div>
                        </div>
                      </div>
                    ) : gatewayNeeded ? (
                    <div className="gateway-setup-instructions">
                      <h4>Step 1: Setup gateway to server</h4>

                      <p className="small-text">Download Microsoft On-Premises Datagateway (standard mode):&nbsp;
                        <a href="https://go.microsoft.com/fwlink/?LinkId=2116849&clcid=0x413" target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>
                          Click here to download Microsoft On-Premises Data Gateway (standard mode)
                        </a>
                      </p>

                      <p className="small-text">
                        Install the downloaded file on the server; when asked to sign in with a Microsoft account, please use these credentials:
                      </p>

                      <div className="gateway-credentials">
                        <table className="credential-table" style={{ marginLeft: '20px' }}>
                          <tr>
                            <td style={{ textAlign: 'left', paddingRight: '10px', width: '80px' }}>E-mail:</td>
                            <td><b>{gateway_UserPrincipal}</b></td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: 'left', paddingRight: '10px', width: '80px' }}>Password:</td>
                            <td><b>{gateway_UserPassword}</b></td>
                          </tr>
                        </table>
                      </div>
                    
                      <div style={{ height: '20px' }}></div>
                      <table className="report-table-1" style={{ height: '10vh', borderBottom: '1px solid lightgrey' }}>
                        <thead>
                          <tr>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '600px' }}>Gateway name</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '700px' }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '600px' }}>
                              {gatewayName.length > 0 ? gatewayName : 'Gateway not found'}
                            </td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '700px' }}>
                              {gatewayName.length > 0 ? '✅ Gateway found' : '❌ Gateway not found. Download and install Microsoft On-Premises-Data-Gateway on the server and login with the credentials as shown above.'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button className="refresh-gateway-button" onClick={() => window.location.reload()}>
                          &#x21BB; Refresh
                      </button>

                      <div style={{ height: '20px' }}></div>
                      <h4>Step 2: Create datasource related to the database and bind it to the BI report</h4>
                      <p className="small-text">
                        Create a datasource to access the database and bind it to the report. This allows the report to (automatically) refresh the dataset.
                      </p>

                      <div className="table-container">
                        <table className="verification-table">
                          <thead>
                            <tr>
                              <th className="table-header" colSpan="2">Datasource</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="left-column">Connection type:</td>
                              <td className="right-column">
                                <select className="select-box">
                                  <option>SQL Server</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td className="left-column">Servername:</td>
                              <td className="right-column">
                                <input
                                  type="text"
                                  className="text-field"
                                  onChange={(e) => handleInputChange(e, setServername)}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="left-column">Database:</td>
                              <td className="right-column">
                                <input
                                  type="text"
                                  className="text-field"
                                  onChange={(e) => handleInputChange(e, setDatabasename)}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="left-column" colspan="2" style={{ fontSize: '0.9em', fontWeight: 'bold' }}>
                                Click <a href="#" style={{ color: 'blue' }} onClick={() => setShowHelp_ServernameDatabase(true)}>here</a> to see where you can find the&nbsp;
                                <span style={{ fontStyle: 'italic' }}>servername</span> and&nbsp;
                                <span style={{ fontStyle: 'italic' }}>database</span>
                                <br/>&nbsp;
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table className="verification-table">
                          <thead>
                            <tr>
                              <th className="table-header" colSpan="2">Verification</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="left-column">Verification method:</td>
                              <td className="right-column">
                                <select className="select-box" onChange={handleSelectVerificationMethodChange}>
                                  <option>Windows</option>
                                  <option>Basis</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td className="left-column">
                                {verificationMethod === "Basis" ? "Username:" : "Domainname\\Username:"}
                              </td>
                              <td className="right-column">
                                <input
                                  type="text"
                                  className="text-field"
                                  onChange={(e) => handleInputChange(e, setUsername)}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="left-column">Password:</td>
                              <td className="right-column flex-container">
                                <input
                                  type={showPassword ? 'text' : 'password'}
                                  className="text-field"
                                  onChange={(e) => handleInputChange(e, setPassword)}
                                />
                                <button
                                  type="button"
                                  className="show-hide-button"
                                  onClick={togglePasswordVisibility}
                                >
                                  {showPassword ? <img src="/Media/Show Icon.png" alt="Show" className="show-hide-icon" /> : <img src="/Media/Hide Icon.png" alt="Hide" className="show-hide-icon" />}
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td className="left-column" colspan="2" style={{ fontSize: '0.9em', fontWeight: 'bold' }}>
                                Click <a href="#" style={{ color: 'blue' }} onClick={() => setShowHelp_VerificationMethod(true)}>here</a> to see where you can find the available&nbsp;
                                <span style={{ fontStyle: 'italic' }}>usernames</span>
                                <br/>&nbsp;
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="button-container">
                        <button
                          className={isButtonActive ? 'button-active' : ''}
                          disabled={!isButtonActive}
                          onClick={handleButton_CreateDatasource}
                        >
                          Connect to database
                        </button>
                      </div>
                      

                      <div style={{ height: '20px' }}></div>
                      <div style={{ height: '20px' }}></div>
                      <table className="report-table-1" style={{ height: '15vh', borderBottom: '1px solid lightgrey' }}>
                        <thead>
                          <tr>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Report name</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>Datasource type</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '500px' }}>Connection details</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '225px' }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                            {
                              DatasetGatewayDatasources && Array.isArray(DatasetGatewayDatasources.value) ? (
                                DatasetGatewayDatasources.value.map((report, index) => (
                                  <tr key={index}>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{report.reportName}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{report.datasourceType}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '500px' }}>{report.connectionDetails}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '225px' }}>
                                      {
                                        report.reportName && report.datasourceType && report.connectionDetails && report.reportName !== 'No report found'
                                          ? '✅ Report connected'
                                          : '❌ Report not connected'
                                      }
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={2}>No datasets binded</td>
                                </tr>
                              )
                            }
                            </tbody>
                      </table>
                      <div style={{ height: '20px' }}></div>
                    </div>
                    
                    
                    ) :  (
                    <div>
                      No connection settings needed or available for this report.
                    </div>
                    )}
                </div>
            )}

            {activeMenu === 'parameters' && (
                <div className="report-table-container-cc">
                    <h3>Report Parameters</h3>

                    {/* Tabel voor de koppen */}
                    <table className="report-table-1">
                        <thead>
                            <tr>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px' }}>Parameter name</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '675px' }}>Value</th>
                            </tr>
                        </thead>
                    </table>

                    {/* Scrollbare div rond de tabel met de rijen */}
                    <div className="scrollable-table-container-cc">
                      <table className="report-table-2-cc">
                      <tbody>
                        {
                          reportParameters && Array.isArray(reportParameters.value) ? (
                            reportParameters.value.map((parameters, index) => {
                              // Als de parameterName gelijk is aan 'CompanyReportsId', render deze regel niet
                              if (parameters.name === 'CompanyReportsId') {
                                return null;
                              }

                              return (
                                <tr key={index}>
                                  <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px' }}>{parameters.name}</td>
                                  <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '675px' }}>
                                    <input 
                                      type="text"
                                      value={parameterValues[index] || parameters.currentValue}
                                      style={{ verticalAlign: 'middle', textAlign: 'left', width: '95%' }}
                                      onChange={(e) => handleParameterValueChange(index, e.target.value)}
                                    />
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={2}>No parameters available</td>
                            </tr>
                          )
                        }
                      </tbody>

                      </table>
                      { userRole !== 3 && 
                      <div>
                        <div style={{ height: '20px' }}></div>
                        <button className="invite-user-button" onClick={handleUpdateParameters} disabled={!parametersChanged}>
                          Update parameters
                        </button>
                      </div>
                      }
                    </div>
                </div>
            )}

            {activeMenu === 'refresh_schedule' && (
                <div className="report-table-container-cc">
                    <h3>Report Refresh Schedule</h3>

                    <div style={{ display: 'flex' }}>
                      <div style={{ marginRight: '50px' }}>
                          <table className="report-table-2-cc" style={{ width: '100%', height: '41vh', borderTop: '1px solid lightgrey', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                              <thead>
                                  <tr>
                                      <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Days in week</th>
                                  </tr>
                              </thead>
                              <tbody>
                              {daysOfWeek.map((day, index) => (
                                <tr key={index}>
                                    <td style={{ width: '30px', textAlign: 'center' }}>
                                        <input 
                                            type="checkbox" 
                                            checked={selectedDays.includes(day)} 
                                            onChange={() => handleDayChange(day)} 
                                        />
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '250px' }}>{day}</td>
                                </tr>
                              ))}
                              </tbody>
                          </table>
                          { userRole !== 3 && 
                          <div>
                              <div style={{ height: '20px' }}></div>
                              <button className="invite-user-button" disabled={!RShasChanges} onClick={handleUpdateRefreshSchedule}>
                                  Update refresh schedule
                              </button>
                          </div>
                          }
                      </div>

                      <div>
                          <table className="report-table-2-cc" style={{ width: '85%', height: '41vh', borderTop: '1px solid lightgrey', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                              <thead>
                                  <tr>
                                      <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>Times per day</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {Array.from({ length: 8 }).map((_, index) => (
                                      <tr key={index}>
                                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '50px', paddingLeft: '5px', margin: '0px' }}>
                                              <select value={selectedHours[index]} onChange={e => handleHourChange(index, e.target.value, e)}>
                                                  <option value="">--</option>
                                                  {Array.from({ length: 12 }, (_, k) => k + 1).map(num => (
                                                      <option key={num} value={num}>{num}</option>
                                                  ))}
                                              </select>
                                          </td>
                                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '50px', paddingLeft: '5px', margin: '0px' }}>
                                          <select value={selectedMinutes[index]} onChange={e => handleMinuteChange(index, e.target.value)}>
                                              {selectedHours[index] === "" && <option value="">--</option>}
                                              <option value="00">00</option>
                                              <option value="30">30</option>
                                          </select>
                                          </td>
                                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '50px', paddingLeft: '5px', margin: '0px' }}>
                                          <select value={selectedPeriod[index]} onChange={e => handlePeriodChange(index, e.target.value)}>
                                              {selectedHours[index] === "" && <option value="">--</option>}
                                              <option value="AM">AM</option>
                                              <option value="PM">PM</option>
                                          </select>
                                          </td>
                                      </tr>
                                  ))}
                              </tbody>
                          </table>
                      </div>

                  </div>

                </div>
            )}

            {activeMenu === 'user_settings' && (
                <div className="report-table-container-cc" style={{ width: '800px' }}>
                    <h3>User settings</h3>

                    {/* Tabel voor de koppen */}
                    <table className="report-table-1">
                        <thead>
                            <tr>
                              <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '525px' }}>User name</th>
                              <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>Visible</th>
                              <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>Active license</th>
                            </tr>
                        </thead>
                    </table>

                    {/* Scrollbare div rond de tabel met de rijen */}
                    <div className="scrollable-table-container-cc">
                      <table className="report-table-2-cc">
                          <tbody>
                          {
                              licensedUsers && Array.isArray(licensedUsers) ? (
                              licensedUsers.map((license, index) => (
                                  <tr key={index}>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '525px' }}>
                                        {license.name}
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>
                                        <input 
                                        type="checkbox" 
                                        checked={license.visible === 1} 
                                        onChange={() => handleVisibleChange(index)} 
                                        />
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>
                                        <input 
                                        type="checkbox" 
                                        checked={license.active === 1} 
                                        onChange={(event) => {
                                          if (event.target.checked) {
                                              // Als de checkbox aangevinkt wordt
                                              setSelectedIndex(index);
                                              checkLicenseStatus(license.companyReportUserId);
                                          } else {
                                              // Als de checkbox uitgevinkt wordt
                                              handleLicenseChange(index);
                                          }
                                      }} 
                                        />
                                    </td>
                                  </tr>
                              ))
                              ) : (
                              <tr>
                                  <td colSpan={2}>No users available</td>
                              </tr>
                              )
                          }
                          </tbody>
                      </table>
                  </div>
                </div>
            )}

        </div>

        {showQuestionYesNoPopup_ActivateLicense && (
            <div className="popup-container">
                <div className="popup-content">
                <h3 style={{ fontWeight: 'normal' }}>{popupLicenseText}</h3>
                <div className="white-space"></div>
                <div className="buttons-container">
                <button onClick={() => {
                    handleLicenseChange(selectedIndex);
                    setShowQuestionYesNoPopup_ActivateLicense(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    Yes
                </button>
                <button onClick={() => {
                    setShowQuestionYesNoPopup_ActivateLicense(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    No
                </button>
                </div>
                {showCommentPopup && <div className="popup">{error}</div>}
                </div>
            </div>
          )}

        {showHelp_ServernameDatabase && (
          <div className="popup-container-variant-2">
              <div className="popup-content-variant-2">
              <h2 style={{ fontWeight: 'normal' }}>Find servername and database</h2>
              <div className="white-space"></div>
              You can find the servername and database in Ridder iQ by following these steps:<br/>
              <div className="white-space"></div>
              <li>Log in into Ridder iQ</li>
              <li>Go to 'Financieel' in the main menu, followed by 'Algemeen'</li>
              <li>Click on 'Instellingen financieel'</li>
              <li>Find the specified text behind 'Controle iQ databasenaam'. This is what you need to enter at the database-field.</li>
              <li>Find the specified text behind 'Controle SQL-instantienaam'. This is what you need to enter at the servername-field.</li><br/>

              <img src={img_RidderIQ_ServerDatabase} style={{ height: '40vh', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />

              <div style={{ height: '50px' }}></div>
              <div className="buttons-container">
                  <button onClick={() => setShowHelp_ServernameDatabase(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                      Close
                  </button>
              </div>
              </div>
          </div>
        )}
        {showHelp_VerificationMethod && (
          <div className="popup-container-variant-2">
              <div className="popup-content-variant-2">
              <h2 style={{ fontWeight: 'normal' }}>Find username</h2>
              <div className="white-space"></div>
              You can find the current available login users by following these steps:<br/>
              <div className="white-space"></div>
              <li>Log in onto the server where Ridder iQ is installed</li>
              <li>Start <b>Microsoft SQL Server Management Studio</b> and log in</li>
              <li>On the left side (tree menu), expand 'Security' and expand 'Logins'</li>
              <li>The expanded login-list are the current available login users (usernames); you can use one of these usernames (and matching password)</li>
              <li>As an alternative you can create a new login (right mouse click and choose 'New Login...')</li>
              <br/>
              <img src={img_RidderIQ_VerificationMethod} style={{ height: '40vh', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />

              <div style={{ height: '50px' }}></div>
              <div className="buttons-container">
                  <button onClick={() => setShowHelp_VerificationMethod(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                      Close
                  </button>
              </div>
              </div>
          </div>
        )}

        {showHelpPopup && (
          <div className="popup-container">
              <div className="popup-content">
              <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
              <div className="white-space"></div>
              <b>From:</b>
              <input
                  type="text"
                  placeholder="Username"
                  className="company-name-input"
                  disabled="true"
                  value={user.name || ""}
              />
              <b>Company:</b>
              <input
                  type="text"
                  placeholder="Company name"
                  className="company-name-input"
                  disabled="true"
                  value={companyName || ""}
              />
              <div style={{ display: 'inline-block', marginRight: '10px' }}>
                  <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                  <select 
                    style={{ display: 'inline-block', width: '150px' }}
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                >
                    <option value="Support">Support</option>
                    <option value="Customization request">Customization request</option>
                </select>
              </div>
              <div className="white-space"></div>
              <div className="white-space"></div>
              <b>Message:</b>
              <div className="white-space"></div>
              <textarea
                  placeholder="Request for support message"
                  className="company-name-input"
                  rows="4"
                  value={Request_message}
                  style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                  onChange={(e) => setRequestMessage(e.target.value)}
              ></textarea>
              <div style={{ height: '50px' }}></div>
              <div className="buttons-container">
                  <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                      Cancel
                  </button>
                  <button
                    onClick={handleSendHelpButton}
                    style={{ color: 'black', fontWeight: 'bold' }}
                  >
                  Send request
                  </button>
              </div>
              </div>
          </div>
        )}

        {showPopupMessage && <div className="popup-message">{message}</div>}
        {showErrorPopup && <div className="popup">{error}</div>}
        {isLoading && 
            <div className="loader-wrapper">
            <div className="loader"></div>
            </div>
        }
    </div>
    </CSSTransition>
  );
}

export default ConfigCompany;